import { render, staticRenderFns } from "./ValentinesDay_foodItem.vue?vue&type=template&id=6ff6700d&scoped=true"
import script from "./ValentinesDay_foodItem.vue?vue&type=script&lang=ts"
export * from "./ValentinesDay_foodItem.vue?vue&type=script&lang=ts"
import style0 from "./ValentinesDay_foodItem.vue?vue&type=style&index=0&id=6ff6700d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff6700d",
  null
  
)

export default component.exports